import React from "react";
import TitleHeader from "../../../../components/Common/TitleHeader";
import {
  ColumnContainer,
  MainText,
  SubText,
} from "../../../../helpers/StyledComponents";
import { Divider, Steps } from "antd";

const History = () => {
  return (
    <ColumnContainer>
      <TitleHeader th="ประวัติความเป็นมา" center />
      <SubText indent>
        คริสตธรรมสัมพันธ์แห่งประเทศไทยหรือ Scripture Union Thailand
        หรือเรียกย่อๆ ว่า SU Thailand ก่อตั้งขึ้นในปี ค.ศ.1970 โดย อ.อาร์โนลด์
        คล้าร์ค ท่านเป็นมิชชันนารีชาวอังกฤษได้รับใช้พระเจ้าอยู่ที่ภูเก็ต
        เริ่มแรก SU Thailand เป็นส่วนหนึ่งของสำนักพิมพ์ OMF (ปัจจุบันคือ
        กนกบรรณาสาร) และได้แยกออกมาในปี 1976 โดยมี อ.อาร์โนลด์ คล้าร์ค
        เป็นประธานคณะกรรมการคนแรก และมี อ.เยาวนิจ เกษตรวัฒนานนท์
        ซึ่งเป็นบุตรบุญธรรมได้เป็นสตาฟเต็มเวลาคนแรก และได้รับหน้าที่เลขาธิการ
        คริสตธรรมสัมพันธ์จนถึงปี 2013
      </SubText>
      <SubText>
        <strong>
          เราได้เข้าเป็นสมาชิกในสังกัดสหกิจคริสเตียนแห่งประเทศไทย ตั้งแต่ปี 2014
          จนถึง ปัจจุบัน สำนักงานปัจจุบันอยู่ที่ชั้น 4 ของอาคารหกชั้น
          คริสตจักรสาธร
        </strong>
      </SubText>
      <Divider />
      <MainText align="center">
        สถานที่ตั้งคริสตธรรมสัมพันธ์ในอดีต 1965-2013
      </MainText>
      <Steps
        progressDot
        style={{ margin: "0px auto", maxWidth: "450px" }}
        current={7}
        direction="vertical"
        items={[
          {
            title: "1965",
            description: "14/1 ถนนศรีเวียง กรุงเทพฯ",
          },
          {
            title: "1966",
            description: "197/2 ถนนสุรวงศ์ พระนคร",
          },
          {
            title: "1974",
            description:
              "(กองบรรณศาสตร์ สีลม กรุงเทพฯ) 111/9 ถนนปั้น สีลม กรุงเทพฯ",
          },
          {
            title: "1977",
            description: "(ประเสริฐบรรณาคาร) 487 ชั้น 2 ถนนสีลม กทม.",
          },
          {
            title: "1978",
            description: "232/38 ถนนนเรศ บางรัก กรุงเทพฯ",
          },
          {
            title: "1988",
            description:
              "800/101-102 ซอยตระกูลสุข ถ.อโศกดินแดง ห้วยขวาง กรุงเทพฯ 10310",
          },
          {
            title: "สถานที่ตั้งคริสตธรรมสัมพันธ์ 2014-ปัจจุบัน",
            description: "274 ถนนสารเหนือ เขตบาง กรุงเทพฯ 10500",
          },
        ]}
      />
      <Divider />
      <MainText align="center">
        SU THAILAND เป็นเครือข่ายของ SCRIPTURE UNION INTERNATIONAL
        ซึ่งเริ่มต้นที่ประเทศอังกฤษเมื่อกว่า 150 ปีที่แล้ว โดยมีจุดมุ่งหมาย 2
        ประการคือ
      </MainText>
      <SubText>
        1. ประกาศข่าวประเสริฐแก่เด็ก เยาวชนและครอบครัว
        <br />
        2. ส่งเสริมให้คนทุกวัยได้เข้าเฝ้าพระเจ้าทุกวัน
        โดยการอ่านพระคัมภีร์และอธิษฐาน
        <br />
        ปัจจุบัน Scripture Union ทำพันธกิจในกว่า 120 ประเทศทั่วโลก โดยในเอเชีย
        เรามีการทำพันธกิจใน 20 ประเทศ
        <br />
        ผู้อำนวยการของ Scripture Union International คนปัจจุบันคือ Monika
        Kuschmierz และมีคณะกรรมการบริหารที่เลือกตั้งจากที่ประชุมสมัชชาโลกของ SU
        คอยสนับสนุน
      </SubText>
      <Divider />
      <MainText align="center">พันธกิจในอนาคต/WAY FORWARD</MainText>
      <SubText indent>
        ตลอด 50 ปีที่ผ่านมา SU Thailand
        มุ่งมั่นที่จะทำพันธกิจในการสนับสนุนการอ่านพระคัมภีร์กับผู้คนทุกเพศทุกวัย
        เพื่อจะติดสนิทกับพระเจ้า ได้รับเชื่อพระเยซูเป็นการส่วนตัว
        และเติบโตในความเชื่อ
        สามารถเป็นพยานและประกาศข่าวประเสริฐของพระเจ้าไปยังสุดปลายแผ่นดินโลก
      </SubText>
      <Divider />
      <MainText align="center">พันธกิจในอนาคตของเราจะมุ่งเน้น</MainText>
      <SubText>
        <ul>
          <li>
            การส่งเสริมอ่านพระคัมภีร์ โดยผลิตสื่อสิ่งพิมพ์
            คู่มือในการสอนและการอ่านพระคัมภีร์ที่ทันสมัย
          </li>
          <li>
            ความร่วมมือกับคริสตจักรและโรงเรียน
            ในการประกาศและส่งเสริมให้เด็กและเยาวชนที่จะรู้จักพระคริสต์
            ผ่านทางกิจกรรมต่างๆ
          </li>
          <li>
            การอบรมการสอนพระคัมภีร์ให้แก่อนุศาสก ครูรวีวารศึกษา
            ตลอดจนพ่อแม่ผู้ปกครองที่สนใจCertificate for Sunday School Teaching
            โดยร่วมมือกับสถาบันกรุงเทพคริสตศาสนศาสตร์(บีไอที)
          </li>
          <li>
            การส่งเสริมให้ครอบครัวเป็นส่วนสำคัญในการเสริมสร้างจิตวิญญาณของเด็กและเยาวชนโดยจัดอบรมสัมมนา
            แลกเปลี่ยนความคิดเห็น
            เพื่อเสริมสร้างครอบครัวให้เป็นสถาบันหลักในการสอนเรื่องราวของพระเจ้าแก่ลูกหลาน
          </li>
          <li>การรับอาสาสมัครเข้ามามีส่วนร่วมในการพันธกิจและในกิจกรรมต่างๆ</li>
          <li>
            ความร่วมมือกับ Scripture Union นานาชาติในพันธกิจต่างๆ
            โดยเฉพาะประเทศเพื่อนบ้านในเอเชีย
          </li>
        </ul>
      </SubText>
      <Divider />
    </ColumnContainer>
  );
};

export default History;
